/**
 * Sets up Mixpanel and registers various super-properties.
 */
define('router/router-tasks/set-mixpanel-identity',['require','api-access','api-access','api-access','mixpanel-helper','shared-g2m-logic'],function (require) {
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var g2mmApi = require('api-access').gotomeet;
    var mixpanelHelper = require('mixpanel-helper');
    var sharedG2mLogic = require('shared-g2m-logic');

    return function () {
        var retrieveUser = $.Deferred();
        var retrieveProducts = $.Deferred();
        var retrieveG2mm = $.Deferred();
        var retrieveCoorganizers = $.Deferred();
        var retrieveTierSettings = $.Deferred();

        userApi.me().then(function (userMe) {
            retrieveUser.resolve(userMe);

            commerceApi.getProducts()
                .then(function (products) {
                    retrieveProducts.resolve(products);
                })
                .fail(function () {
                    retrieveProducts.resolve();
                });
        });

        g2mmApi.getByUserKey()
            .then(function () {
                retrieveG2mm.resolve('RESERVED');
            })
            .fail(function () {
                retrieveG2mm.resolve('UNRESERVED');
            });

        userApi.getFilteredCoorganizers('', '').then(function (coorganizers) {
            retrieveCoorganizers.resolve(coorganizers);
        });

        $.when(userApi.tierSettings('g2m'), userApi.tierSettings('g2mfree'))
            .then(function (g2mResponse, g2mFreeResponse) {
                retrieveTierSettings.resolve([g2mResponse[0], g2mFreeResponse[0]]);
            })
            .fail(function () {
                retrieveTierSettings.reject('ERROR');
            });

        $.when(retrieveUser, retrieveProducts, retrieveG2mm, retrieveCoorganizers, retrieveTierSettings)
            .then(function (userMe, products, g2mmStatus, coorganizers, tierSettings) {
                sharedG2mLogic.mixpanel.setSuperProperties(window.mixpanel, {
                    userMe: userMe,
                    products: products,
                    g2mmStatus: g2mmStatus,
                    coorganizers: coorganizers
                });

                var onboardingViewed = tierSettings.some(function (tierSetting) {
                    return tierSetting.onboardingViewed;
                });
                window.mixpanel.register({'Onboarding Viewed': onboardingViewed});

                mixpanelHelper.onSuperPropertiesLoad();
            });
    };
});

